import React, { Component } from 'react';
import { map} from 'lodash';

class VariationNumber extends Component {
  render() {
    const style={
      units:{
        color:"#fff"
      }
    };
    const {commonReducer,title} = this.props;
    let currentWeek_newJobQuotesCount  = 0;
    map(commonReducer && commonReducer.currentWeek_openJobs && commonReducer.currentWeek_openJobs["newJobQuotes"],(data)=>{
      if(data){
        currentWeek_newJobQuotesCount = currentWeek_newJobQuotesCount + data.count;
      }
    });
    let previousWeek_newJobQuotesCount = 0;
    map(commonReducer && commonReducer.previousWeek_openJobs && commonReducer.previousWeek_openJobs["newJobQuotes"],(data)=>{
      if(data){
        previousWeek_newJobQuotesCount = previousWeek_newJobQuotesCount + data.count;
      }
    });
    let diff_newJobQuotesCount = currentWeek_newJobQuotesCount - previousWeek_newJobQuotesCount;
    let currentWeek_jobAcceptedCount = 0;
    map(commonReducer && commonReducer.currentWeek_openJobs && commonReducer.currentWeek_openJobs["jobAccepted"],(data)=>{
      if(data){
        currentWeek_jobAcceptedCount = currentWeek_jobAcceptedCount + data.count;
      }
    });
    let previourWeek_jobAcceptedCount = 0;
    map(commonReducer && commonReducer.previousWeek_openJobs && commonReducer.previousWeek_openJobs["jobAccepted"],(data)=>{
      if(data){
        previourWeek_jobAcceptedCount = previourWeek_jobAcceptedCount + data.count;
      }
    });
    let diff_jobAcceptedCount = currentWeek_jobAcceptedCount - previourWeek_jobAcceptedCount;
    let ppreviourWeek_jobAcceptedCount = 0;
    map(commonReducer && commonReducer.ppreviousWeek_openJobs && commonReducer.ppreviousWeek_openJobs["jobAccepted"],(data)=>{
      if(data){
        ppreviourWeek_jobAcceptedCount = ppreviourWeek_jobAcceptedCount + data.count;
      }
    });
    let diff_previousweek_jobAcceptedCount = previourWeek_jobAcceptedCount - ppreviourWeek_jobAcceptedCount;
    let currentWeek_declinedCount = 0;
    map(commonReducer && commonReducer.currentWeek_openJobs && commonReducer.currentWeek_openJobs["declined"],(data)=>{
      if(data){
        currentWeek_declinedCount = currentWeek_declinedCount + data.count;
      }
    });
    let previousWeek_declinedCount = 0;
    map(commonReducer && commonReducer.previousWeek_openJobs && commonReducer.previousWeek_openJobs["declined"],(data)=>{
      if(data){
        previousWeek_declinedCount = previousWeek_declinedCount + data.count;
      }
    });
    let ppreviousWeek_declinedCount = 0;
    map(commonReducer && commonReducer.ppreviousWeek_openJobs && commonReducer.ppreviousWeek_openJobs["declined"],(data)=>{
      if(data){
        ppreviousWeek_declinedCount = ppreviousWeek_declinedCount + data.count;
      }
    });
    let diff_declinedCount = currentWeek_declinedCount - previousWeek_declinedCount;
    let diff_previous_declinedCount = previousWeek_declinedCount - ppreviousWeek_declinedCount;
    return (
      <div className="col-md-6 mpad0 padLeft0 " onClick={this.props.clickHandler}>
        <div className="overview-card">
          <a>
            <i className="mdi mdi-chevron-right" />
            <h5 className="text-wrap">{this.props.title}</h5>
            <ul className="job-list-data list-data list-unstyled">
              <li>
                <label>
                  <span className="variation inc">{title == "Applied" ? diff_newJobQuotesCount : title == "Confirmed" ? diff_jobAcceptedCount : title == "Declined" ? diff_declinedCount :{}}
                  <i className={title == "Applied" ? diff_newJobQuotesCount >= 0 ? "mdi mdi-menu-up" : "mdi mdi-menu-down" : title == "Confirmed" ? diff_jobAcceptedCount > 0 ? "mdi mdi-menu-up" : "mdi mdi-menu-down" : title == "Declined" ? diff_declinedCount >=0 ? "mdi mdi-menu-up" : "mdi mdi-menu-down" :{}}></i>
                  </span>{title == "Applied" ? commonReducer && commonReducer.currentWeek_avgResponseTime && commonReducer.currentWeek_avgResponseTime.avgResponseTime : title == "Confirmed" ? currentWeek_jobAcceptedCount : title == "Declined" ? currentWeek_declinedCount :{}}
                  <span className="units" style={this.props.title=="Confirmed"? {}:style.units}>min</span>
                </label>
               {this.props.title=="Applied" && <span className="response-time">Response Time</span>}
                <span className="sub-text">This Week</span>
              </li>
              <li>
                <label>
                  <span className="variation inc">{title == "Applied" ? diff_newJobQuotesCount : title == "Confirmed" ? diff_previousweek_jobAcceptedCount : title == "Declined" ? diff_previous_declinedCount :{}}
                    <i className="mdi mdi-menu-up"></i>
                  </span>
                    {title == "Applied" ? commonReducer && commonReducer.previousWeek_avgResponseTime && commonReducer.previousWeek_avgResponseTime.avgResponseTime : title == "Confirmed" ? previourWeek_jobAcceptedCount : title == "Declined" ? previousWeek_declinedCount :{}}
                  <span className="units" style={this.props.title=="Confirmed"? {}:style.units}>min</span>
                </label>
               {this.props.title=="Applied" && <span className="response-time">Response Time</span>}
                <span className="sub-text">Last Week</span>

              </li>
            </ul>
          </a>
        </div>
      </div>
    );
  }
}

export default VariationNumber;



// WEBPACK FOOTER //
// ./src/components/OpenJobs/VariationNumber.jsx